import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedComponents } from "../../shared.module";

/**
 * Component to display the details of a user story, including its review comments and other relevant information.
 * Allows toggling the visibility of additional details and editing the user story attributes like weightage and coverage.
 */
@Component({
  selector: "app-user-story-detail-view",
  standalone: true,
  imports: [CommonModule, MatIconModule, SharedComponents],
  templateUrl: "./user-story-detail-view.component.html",
  styleUrl: "./user-story-detail-view.component.scss",
})
export class UserStoryDetailViewComponent implements OnInit {
  activeModal = inject(NgbActiveModal);

  @Input()
  data: any = {};
  isActive: boolean = false;

  processedKeys: { key: string; value: any }[] = [];
  isShowDetails: boolean = false;

  /**
   * Lifecycle hook that is triggered when the component is initialized.
   * Processes the review comments if available in the input data.
   */
  ngOnInit() {
    if (this.data?.testReview?.review_comments) {
      this.processedKeys = Object.entries(
        this.data.testReview.review_comments
      ).map(([key, value]) => ({
        key,
        value,
      }));
    }
    console.log(this.data);
    console.log(this.processedKeys);
  }

  /**
   * Transforms a key by capitalizing the first letter of each word and joining them with spaces.
   * @param key The key to transform.
   * @returns The transformed string with capitalized words.
   */
  transformKey(key: string): string {
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
      .join(" ");
  }

  /**
   * Toggles the visibility of additional details for the user story.
   * This flag is used to show or hide extra information such as comments or attributes.
   */
  showDetails() {
    this.isShowDetails = !this.isShowDetails;
  }

  /**user-data
   * Handles review comments interaction.
   * @param comment The comment object to handle.
   */
  reviewComments(comment: any) {
    console.log('Review comment:', comment);
  }

  /**
   * Edits the weightage attribute of the user story.
   * @param data The data for weightage to be edited.
   */
  editWeightage(data: any) {
    console.log('Edit weightage:', data);
  }

  /**
   * Edits the coverage attribute of the user story.
   * @param data The data for coverage to be edited.
   */
  editCoverage(data: any) {
    console.log('Edit coverage:', data);
  }
}
